module.exports = __webpack_public_path__ + "assets/img/Deauville_003.5180d3f0.jpg";